"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineObject = void 0;
const iplanning_item_search_entity_1 = require("./iplanning-item-search-entity");
function parseInlineObject(data) {
    if (data.planning_item_filter !== null && typeof data.planning_item_filter === 'object')
        data.planning_item_filter = (0, iplanning_item_search_entity_1.parseIPlanningItemSearchEntity)(data.planning_item_filter);
    return data;
}
exports.parseInlineObject = parseInlineObject;
